/**
 * Builds the non-blocking notice shown when competitor variables are requested
 * but absent from the input file.
 *
 * The chosen behaviour is drop-and-tell: the tile renders normally with the
 * remaining competitors so the dashboard stays usable, but the discrepancy is
 * named — including the variable names — so an operator can act on it rather
 * than silently trusting a total that is missing a contributor.
 *
 * @returns The notice text, or `null` when there is nothing to report.
 */
export const formatMissingVariablesNotice = (
    missingVariables: string[],
): string | null => {
    if (!missingVariables.length) {
        return null;
    }

    const isSingle = missingVariables.length === 1;

    const parts = [
        `${missingVariables.length} competitor`,
        isSingle ? 'variable is' : 'variables are',
        'not available in the input file and',
    ];

    if (!isSingle) {
        parts.push('are');
    }

    parts.push(`excluded from this total: ${missingVariables.join(', ')}.`);

    return parts.join(' ');
};
